import React, { Component } from "react";
import { Button, Form, Segment, Header, Message } from "semantic-ui-react";
import gql from "graphql-tag";
import { Mutation } from "react-apollo";
import { GraphQLError } from "components/GraphQLError";

class Login extends Component {
  state = {
    email: "",
    password: "",
    message: ""
  };

  async componentDidMount() {
    const token = await localStorage.getItem("token");
    // if (!!token) {
    //   this.props.history.push(this.props.location.state ? this.props.location.state.from : "/applications");
    // }
  }

  handleChange = event => {
    this.setState({ [event.target.id]: event.target.value });
  };

  render() {
    return (
      <div style={styles.grid}>
        <div />
        <div style={styles.header}>
          <Header as="h1" content="Platform Content" />
        </div>
        <div />

        <div />
        <div>
          <Segment>
            <Form>
              <Form.Field>
                <label>Email</label>
                <input
                  id="email"
                  placeholder="Email"
                  type="email"
                  onChange={this.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Password</label>
                <input
                  id="password"
                  placeholder="Password"
                  type="password"
                  onChange={this.handleChange}
                />
              </Form.Field>

              {this.state.message && (
                <Message danger>{this.state.message}</Message>
              )}
              <Mutation mutation={AUTH_MUTATION}>
                {(auth, { data, loading, error }) => {
                  if (error) {
                    console.log(error);
                  }
                  return (
                    <React.Fragment>
                      {error && <GraphQLError error={error} />}
                      <Button
                        loading={loading}
                        onClick={async () => {
                          this.setState({ message: "" });
                          const authResponse = await auth({
                            variables: {
                              username: this.state.email,
                              password: this.state.password
                            }
                          });

                          if (authResponse.data.auth.isAdmin) {
                            localStorage.setItem(
                              "token",
                              authResponse.data.auth.access_token
                            );

                            this.props.history.push(this.props.location.state ? this.props.location.state.from : "/applications");
                          } else {
                            this.setState({
                              message: "User lacks admin privileges."
                            });
                          }
                        }}
                      >
                        Submit
                      </Button>
                    </React.Fragment>
                  );
                }}
              </Mutation>
            </Form>
          </Segment>
        </div>
        <div />
      </div>
    );
  }
}

const AUTH_MUTATION = gql`
  mutation Auth($username: String!, $password: String!) {
    auth(username: $username, password: $password) {
      access_token
      isAdmin
    }
  }
`;

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 540px 1fr",
    gridTemplateRows: "240px 350px"
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
};

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login/index.js